import gql from 'graphql-tag'

export const CREATE_RITAGE_GEOFENCE = gql`
  mutation CreateRitageGeofence($input: CreateRitageGeofenceInput!) {
    createRitageGeofence(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createRitageGeofence {
        ritageName
        geofenceLoading {
          geofenceId
          fenceName
          polyData
          circData
        }
        geofenceDumping {
          geofenceId
          fenceName
          polyData
          circData
        }
      }
    }
  }
`

export const GET_RITAGE_GEOFENCES = gql`
  query RitageGeofences($filter: GetRitageGeofencesFilter) {
    ritageGeofences(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      ritageGeofences {
        data {
          ritageName
          geofenceLoading {
            geofenceId
            fenceName
            polyData
            circData
          }
          geofenceDumping {
            geofenceId
            fenceName
            polyData
            circData
          }
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const GET_RITAGE_GEOFENCE = gql`
  query RitageGeofence($filter: GetRitageGeofenceFilter!) {
    ritageGeofence(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      ritageGeofence {
        ritageName
        geofenceLoading {
          geofenceId
          fenceName
          polyData
          circData
        }
        geofenceDumping {
          geofenceId
          fenceName
          polyData
          circData
        }
      }
    }
  }
`

export const UPDATE_RITAGE_GEOFENCE = gql`
  mutation UpdateRitageGeofence($input: UpdateRitageGeofenceInput!) {
    updateRitageGeofence(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateRitageGeofence {
        ritageName
        geofenceLoading {
          geofenceId
          fenceName
          polyData
          circData
        }
        geofenceDumping {
          geofenceId
          fenceName
          polyData
          circData
        }
      }
    }
  }
`

export const DELETE_RITAGE_GEOFENCE = gql`
  mutation DeleteRitageGeofence($input: DeleteRitageGeofenceInput!) {
    deleteRitageGeofence(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deleteRitageGeofence {
        ritageName
        geofenceLoading {
          geofenceId
          fenceName
          polyData
          circData
        }
        geofenceDumping {
          geofenceId
          fenceName
          polyData
          circData
        }
      }
    }
  }
`
